module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/vi/4/3-2ad5af8c6ad3d9f82919dc9526357f5c.jpg";